import React, { createRef } from 'react';
import IdleTimer from 'react-idle-timer';
import { UT } from 'core/constants';
import { inject } from 'mobx-react';
import CONFIG from 'core/globals';

class IdleTimerContainer extends React.Component {
  idleTimerRef = createRef();

  _onActive = async() => {
    const { type, actions } = this.props;
    if (type === UT.USER) {
      await actions.widget.back();
    }
  };

  _onIdle = async() => {
    const { type, actions } = this.props;
    if (type === UT.USER) {
      await actions.widget.leave();
    }
  };

  render() {
    return (
      <IdleTimer
        ref={this.idleTimerRef}
        element={document}
        onActive={this._onActive}
        onIdle={this._onIdle}
        timeout={CONFIG.IdleTimer}
      />
    );
  }
}

export default inject('actions')(IdleTimerContainer);
